import Link from '@/atoms/Link/Link'

interface Props {
  breadcrumbItems: Breadcrumb[]
}

const Breadcrumbs = ({ breadcrumbItems }: Props) => {
  if (breadcrumbItems.length <= 1) {
    return null
  }
  return (
    <ol className="flex text-small max-w-2xl whitespace-nowrap overflow-hidden">
      {breadcrumbItems.map(({ name, url }, index) =>
        breadcrumbItems.length - 1 === index ? (
          <li
            className="overflow-hidden text-ellipsis"
            aria-current="location"
            key={name}
          >
            {name}
          </li>
        ) : (
          <li key={name}>
            <Link href={url} className="mr-2">
              {name}
            </Link>
            <span className="mr-2" aria-hidden="true">
              /
            </span>
          </li>
        )
      )}
    </ol>
  )
}
export default Breadcrumbs
